import { createElement, useEffect, useState, useRef } from 'react';
import { Grid } from '@alifd/next';
import { get, set, cloneDeep, unset, isEmpty } from 'lodash';
import { defaultSchema } from './utils';
import JsonSchema from './jsonSchema';
import './style.less';
const { Row, Col } = Grid;
const JsonSchemaEditor = (props) => {
    const { data, onChange, isReset } = props;
    const [open, setOpen] = useState({ properties: true });
    const [schema, setSchema] = useState({});
    const [fieldNum, setFieldNum] = useState(1);
    const [flag, sestFlag] = useState(false);
    const saveJson = useRef({});
    const setSchems = (val) => {
        setSchema(val);
        sestFlag(!flag);
    };
    const Model = {
        changeValueAction: (keys, value) => {
            if (value !== undefined || value !== null) {
                Model.setData(keys, value);
            }
        },
        setData: (keys = [], value) => {
            if (keys.length === 0) {
                setSchems(value);
            }
            else {
                const schemaNew = set(schema, keys.join('.'), value);
                setSchems(schemaNew);
            }
        },
        getData: (keys = []) => {
            if (keys.length === 0)
                return schema;
            return get(schema, keys.join('.'));
        },
        setOpenValueAction: (keyArr, openValue) => {
            const key = keyArr.join('.');
            const openStatus = get(open, key);
            setOpen({ ...open, [key]: openValue || !openStatus });
        },
        getOpenValue: (keys = []) => {
            return get(open, keys.join('.'));
        },
        addChildFieldAction: (prefix) => {
            setFieldNum(fieldNum + 1);
            const ranName = `field_${fieldNum}`;
            const key = [].concat(prefix, ranName);
            Model.setData(key, cloneDeep(defaultSchema.string));
        },
        addFieldAction: (prefix) => {
            setFieldNum(fieldNum + 1);
            const ranName = `field_${fieldNum}`;
            const key = [].concat(prefix, ranName);
            Model.setData(key, cloneDeep(defaultSchema.string));
        },
        changeTypeAction: (keys = [], type) => {
            const parentsKeys = Model.getParentKeys(keys);
            const parentsData = Model.getData(parentsKeys);
            if (parentsData.type === type)
                return;
            const newData = {
                ...cloneDeep(defaultSchema[type]),
                description: parentsData.description
                    ? parentsData.description
                    : '',
            };
            Model.setData(parentsKeys, newData);
        },
        getParentKeys: (keys = []) => {
            if (keys.length === 1)
                return [];
            const arr = [].concat(keys);
            arr.splice(keys.length - 1, 1);
            return arr;
        },
        changeNameAction: (prefix, name, value) => {
            const keys = prefix;
            const propertiesData = Model.getData(keys);
            const newPropertiesData = {};
            const curData = propertiesData[name];
            const openKeys = [].concat(keys, value, 'properties').join('.');
            const oldOpenKeys = [].concat(keys, name, 'properties').join('.');
            if (curData.properties) {
                const newOpen = open;
                delete newOpen[oldOpenKeys];
                newOpen[openKeys] = true;
                setOpen(newOpen);
            }
            if (propertiesData[value] &&
                typeof propertiesData[value] === 'object') {
                return;
            }
            Object.keys(propertiesData).forEach((key) => {
                if (key === name) {
                    newPropertiesData[value] = propertiesData[key];
                }
                else {
                    newPropertiesData[key] = propertiesData[key];
                }
            });
            Model.setData(keys, newPropertiesData);
        },
        addArrayItems: (prefix, fields) => {
            const oldSchema = schema;
            const oldItems = get(oldSchema, prefix);
            if (!oldItems) {
                Model.setData(prefix, [fields, fields]);
            }
            else {
                const newItems = oldItems.concat(fields);
                Model.setData(prefix, newItems);
            }
        },
        deleteArrayItems: (prefix, index) => {
            const oldSchema = schema;
            const oldItems = get(oldSchema, prefix);
            oldItems.splice(index, 1);
            Model.setData(prefix, oldItems);
            const key = prefix.filter((item) => item !== 'properties');
            const itemsIndex = key.findIndex((item) => item === 'fields');
            key.splice(itemsIndex, 1, index);
            unset(saveJson.current, key);
            onChange && onChange(saveJson.current);
        },
        setSaveValue: (prefix = [], value, index) => {
            if (typeof index === 'number') {
                const key = prefix.filter((item) => item !== 'properties');
                const itemsIndex = key.findIndex((item) => item === 'items');
                key.splice(itemsIndex, 1, index);
                set(saveJson.current, key, value);
            }
            else {
                const key = prefix.filter((item) => item !== 'properties');
                set(saveJson.current, key, value);
            }
            onChange && onChange(saveJson.current);
        },
    };
    const showEdit = () => { };
    useEffect(() => {
        if (!isEmpty(data)) {
            setSchema(data);
        }
        if (isReset) {
            saveJson.current = {};
        }
    }, [data, isReset]);
    return (createElement("div", { className: "json-schema-react-editor" },
        createElement(Col, { span: 24, className: "wrapper object-style" },
            createElement(Row, { fixed: true },
                createElement(Col, { span: 12, className: "col-item name-item col-item-name", style: { textAlign: 'center' } },
                    createElement("span", { style: { textAlign: 'center' } }, "\u5C5E\u6027\u540D\u79F0")),
                createElement(Col, { span: 10, className: "col-item col-item-desc", style: { textAlign: 'center' } },
                    createElement("span", { style: { textAlign: 'center' } }, "\u5C5E\u6027\u503C"))),
            createElement(JsonSchema, { data: schema, showEdit: showEdit, model: Model, open: open }))));
};
export default JsonSchemaEditor;
